export const PDF_VISUAL_STATES = {
  pending: 'pending',
  ready: 'ready',
  unavailable: 'unavailable',
  error: 'error',
}

const setVisualState = (chartContext, state) => {
  const chartElement = chartContext?.el
  const visualElement = chartElement?.closest?.('[data-pdf-visual-kind="chart"]')

  if (visualElement) {
    visualElement.dataset.pdfVisualState = state
  }
}

const composeEvent = (existingEvent, state) =>
  function pdfVisualEvent(...args) {
    setVisualState(args[0], state)
    if (typeof existingEvent === 'function') {
      return existingEvent(...args)
    }
    return undefined
  }

export const withPdfChartReadiness = (options = {}) => {
  const chart = options.chart || {}
  const events = chart.events || {}

  return {
    ...options,
    chart: {
      ...chart,
      events: {
        ...events,
        beforeMount: composeEvent(events.beforeMount, PDF_VISUAL_STATES.pending),
        mounted: composeEvent(events.mounted, PDF_VISUAL_STATES.ready),
        updated: composeEvent(events.updated, PDF_VISUAL_STATES.ready),
        animationEnd: composeEvent(events.animationEnd, PDF_VISUAL_STATES.ready),
      },
    },
  }
}
